import { render, staticRenderFns } from "./AllEntitiesDetails.vue?vue&type=template&id=1484fe0e"
import script from "./AllEntitiesDetails.vue?vue&type=script&lang=js"
export * from "./AllEntitiesDetails.vue?vue&type=script&lang=js"
import style0 from "./AllEntitiesDetails.vue?vue&type=style&index=0&id=1484fe0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports